import { useState } from 'react';
import { Box } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';
import { TogglerInput, useInputHelper } from 'framework/form';
import { Modal } from 'framework/ui/ui-builder';

const IsFinalChangesToggle = ({ source }: { source: string }) => {
  const { getValue, getRawOnChangeCallback } = useInputHelper({ source });
  const [isConfirmationShown, setIsConfirmationShown] = useState(false);
  const rawOnChangeCallback = getRawOnChangeCallback() || (() => {});
  const value = getValue();

  const onShareToggleClick = (data: Dictionary<boolean>) => {
    if (data[source]) {
      setIsConfirmationShown(true);
    } else {
      hideConfirmation();
      rawOnChangeCallback({
        [source]: data[source],
      });
    }
  };

  const hideConfirmation = () => {
    setIsConfirmationShown(false);
  };

  const onConfirm = () => {
    hideConfirmation();
    rawOnChangeCallback({
      [source]: true,
    });
  };

  const confirmBtn = (
    <Button key="modal-confirm-button" onClick={onConfirm}>
      Confirm
    </Button>
  );

  return (
    <Box mt={-0.5} mb={-1}>
      <TogglerInput
        source={source}
        value={!!value}
        checkedValue="Yes"
        uncheckedValue="No"
        label="Are final changes?"
        onChangeCallback={onShareToggleClick}
        isControlledInput
        sx={{
          mb: 1.5,
          '& .MuiSwitch-track': {
            '&::before, &::after': {
              fontSize: '12px',
            },
            '&::before': {
              left: '11px !important',
            },
          },
        }}
      />
      <Modal isOpen={isConfirmationShown} title="Are you sure?" buttons={[confirmBtn]} onToggle={hideConfirmation}>
        Once the form is submitted, you cannot change the invoice document
      </Modal>
    </Box>
  );
};

export default IsFinalChangesToggle;
